require('./mortgageRequestEstates.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { cloneDeep, isEmpty, map, merge, get, set, each, isArray, every, find } = require('lodash');
const { connect } = require('react-redux');

// @ commons
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButton } = require('commonsComponents/radioButton');
const OKModal = require('components/commons/OKModal/OKModal');

// @ components
const address = require('./components/address');
const registralData = require('./components/registralData');

// @ constants
const { text, LIVING_PLACE_DATA, MAP_DATA, TYPE_OF_ROADS, dataTypes } = require('./initialValues');

// @ actions
const getLocationData = require('actions/mortgageRequest/mortgageRequestLocationData');

class LivingPlace extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalOpen: false
        };

        this.data = cloneDeep(LIVING_PLACE_DATA);

        this.handleChangeData = this.handleChangeData.bind(this);
        this.buildData = this.buildData.bind(this);
        this.handleOnModalClose = this.handleOnModalClose.bind(this);
    }

    componentDidMount() {
        this.props.onBuildData(this.buildData);
        this.props.requestProvincesData();

        if (!isEmpty(this.props.addressData)) {

            this.setData();
        }
    }

    componentWillUnmount() {
        this.props.onBuildData(undefined);
    }

    setData() {
        const addressData = this.props.addressData;

        if (!isEmpty(addressData)) {
            addressData.populationList && this.setPopulationData(addressData.populationList);
            addressData.registerList && this.setRegistersData(addressData.registerList);

            const typeOfRoad = find(TYPE_OF_ROADS, { value: addressData.streetType });

            const data = {
                additionalEstateInfo: {
                    fields: {
                        estateType: addressData.idType
                    },
                },
                address: {
                    fields: {
                        typeOfRoad,
                        province: addressData.provinceData,
                        population: addressData.populationData,
                        roadName: addressData.street,
                        numberStreet: addressData.streetNumber.toString(),
                        another: addressData.addressOthers || addressData.streetBlock,
                        postalCode: addressData.postalCode
                    },
                },
                addRegCode: {
                    fields: {
                        cruIdufir: addressData.idufir
                    },
                },
                addRegData: {
                    fields: {
                        province: addressData.provinceData,
                        population: addressData.populationData,
                        registerName: addressData.registerData,
                        estateNumber: addressData.registerFincaNumber,
                        estateSection: addressData.registerSection,
                        estateBook: addressData.registerBook,
                        estateVolume: addressData.registerVolume,
                        estateFolio: addressData.registerFolio
                    },
                }
            };

            this.data = merge(this.data, data);
        }
    }

    setPopulationData(populationList = false) {
        if (populationList) {
            this.population = map(populationList, population => ({ label: population.name, value: population.id }));

        } else {
            const { mortgageRequestLocationData } = this.props;
            const populationData = mortgageRequestLocationData.get('populationData').toJS();
            const formId = 'mainForm';
            const stateFormId = populationData.formItemId;

            if (formId === stateFormId) {
                this.population = populationData.populationsList && populationData.populationsList.map(data => ({ label: data.name, value: data.id }));
            }
        }

    }

    setProvincesData() {
        const { mortgageRequestLocationData } = this.props;
        this.provinces = mortgageRequestLocationData.get('provincesList').toJS().map(data => ({ label: data.name, value: data.id }));
    }

    setRegistersData(registersList = false) {
        if (registersList) {
            this.registers = map(registersList, register => ({ label: register.name, value: register.id }));

        } else {
            const { mortgageRequestLocationData } = this.props;
            const registersData = mortgageRequestLocationData.get('registersData').toJS();
            const formId = 'mainForm';
            const stateFormId = registersData.formItemId;


            if (formId === stateFormId) {
                this.registers = registersData.registersList && registersData.registersList.map(data => ({ label: data.name, value: data.id }));
            }

        }
    }

    buildAddress() {
        const addressParameters = {
            data: this.data.address,
            provinces: this.provinces,
            population: this.population,
            onChange: (name, value) => {

                if (name === 'population' || name === 'province') {

                    this.handleChangeData('addRegData', name, value);
                }

                return this.handleChangeData('address', name, value);
            }
        };

        const addressOptions = {
            another: {
                label: 'ANOTHER'
            }
        };

        const address_ = address(addressParameters, addressOptions);

        return (
            <div className="row mortgage-request-estates__row">
                {address_}
            </div>
        )
    }

    buildCruIdufir() {
        if (this.data.additionalEstateInfo.fields.estateType === dataTypes.CRU) {

            return (
                <div className="row mortgage-request-estates__row-child">
                    <div className="col-xs-6">
                        <InputSafe
                            maxLength={14}
                            name="cruIdufir"
                            type="text"
                            value={this.data.addRegCode.fields.cruIdufir}
                            onChange={evt => this.handleChangeData('addRegCode', 'cruIdufir', evt.target.value)}
                            errorMessage={text().MESSAGES.REQUIRED}
                            errorState={this.data.addRegCode.validation.cruIdufir}
                        />
                    </div>
                </div>
            );
        }
    }

    buildData() {
        const additionalEstateSelected = get(this.data, 'additionalEstateInfo.fields.estateType', 'address');
        let newMap = {};
        let isValidAditionalInfo = true;

        this.mapData = cloneDeep(MAP_DATA);
        this.showValid('address');

        if (additionalEstateSelected === dataTypes.CRU) {
            this.showValid('addRegCode');
            isValidAditionalInfo = this.isValid('addRegCode');
        }

        if (additionalEstateSelected === dataTypes.REG_DATA) {
            this.showValid('addRegData');
            isValidAditionalInfo = this.isValid('addRegData');
        }

        if (this.isValid('address') && isValidAditionalInfo) {
            each(this.mapData, (valueMap, keyMap) => {
                newMap[keyMap] = valueMap.default;
                newMap = this.mergeData(newMap, valueMap, keyMap, 'address');
                newMap = this.mergeData(newMap, valueMap, keyMap, 'additionalEstateInfo');

                if (additionalEstateSelected === dataTypes.CRU) {
                    newMap = this.mergeData(newMap, valueMap, keyMap, 'addRegCode');
                }

                if (additionalEstateSelected === dataTypes.REG_DATA) {
                    newMap = this.mergeData(newMap, valueMap, keyMap, 'addRegData');
                }
            });

            if (this.props.addressData.id) {
                newMap.id = this.props.addressData.id;
                newMap.simpleNoteFlag = this.props.addressData.simpleNoteFlag;
            }

            return newMap;
        } else {
            const allInvalid = every(this.data.address.validation, val => val !== false);
            if (allInvalid) {
                this.setState({ isModalOpen: true })
            }
            return false;
        }
    }

    buildModal() {
        return (
            <OKModal
                content="mortgageRequestEstates-livingPlaceErrorModal"
                footerType="action"
                isOpen={this.state.isModalOpen}
                onCloseCallback={this.handleOnModalClose}
                onPrimaryButtonClick={this.handleOnModalClose}
                primaryButtonText="mortgageRequestCommons-acceptButtonText"
            />
        );
    }

    buildRadioButton(type) {

        return (
            <div className="col-xs-12">
                <RadioButton
                    id={`radioButtonLivingPlace-${type}`}
                    name={'radioButtonLivingPlace'}
                    className="block-step__radio"
                    label={text().LIVING_PLACE.OPTIONS[type]}
                    value={type}
                    onChange={value => this.handleChangeData('additionalEstateInfo', 'estateType', value)}
                    isChecked={this.data.additionalEstateInfo.fields.estateType === type}
                />
            </div>
        );
    }

    buildRegData() {
        if (this.data.additionalEstateInfo.fields.estateType === dataTypes.REG_DATA) {
            const registralParameters = {
                data: this.data.addRegData,
                provinces: this.provinces,
                population: this.population,
                registers: this.registers,
                onChange: (name, value) => {
                    if (name === 'population' || name === 'province') {
                        this.handleChangeData('address', name, value);
                    }
                    return this.handleChangeData('addRegData', name, value);
                }
            };

            const regData = registralData(registralParameters, true);
            return (
                <div className="row mortgage-request-estates__row-child">
                    {regData}
                </div>
            )
        }
    }

    handleChangeData(type, name, value) {
        const addressForm = 'mainForm';
        if (name === 'province' && value.length !== 0) {
            this.props.requestLocationData(value.value, undefined, addressForm);
            set(this.data, [type, 'fields', name], value);
            return false;
        }

        if (name === 'population' && value.length !== 0) {
            const province = this.data.address.fields.province.value;
            const population = value.value;
            this.props.requestLocationData(province, population, addressForm);
            set(this.data, [type, 'fields', name], value);
            return false;
        }

        if (isArray(value) && value.length === 0) {
            value = cloneDeep(LIVING_PLACE_DATA[type].fields[name]);
        }

        if (name === 'postalCode') {
            const postalCodeFormat = /[^0-9]|[^\d]+$/g;

            set(this.data, [type, 'fields', name], value.replace(postalCodeFormat, '').trim());
        } else {

            set(this.data, [type, 'fields', name], value);
        }

        this.forceUpdate();
    }

    handleOnModalClose() {
        this.setState({
            isModalOpen: false
        });
    }

    isValid(name) {
        return every(this.data[name].validation, val => val === false);
    }

    mergeData(map, valueMap, keyMap, type) {
        const newMap = map;
        each(this.data[type].fields, (value, key) => {
            if (key === valueMap.field) {
                if (typeof value === 'object') {
                    if (value.value !== '') {
                        map[keyMap] = value.value;
                    }
                } else {
                    map[keyMap] = value;
                }
            }
        });
        return newMap;
    }

    showValid(name) {

        each(this.data[name].fields, (field, key) => {
            if (key !== 'another') {

                if (typeof field === 'object') {
                    set(this.data, `${name}.validation.${key}`, field.value === '');
                } else {
                    set(this.data, `${name}.validation.${key}`, field === '');
                }
            }
        });
        this.forceUpdate();
    }

    render() {
        const textValue = text();
        this.setProvincesData();
        this.setPopulationData();
        this.setRegistersData();

        return (
            <div className="row">
                {this.buildModal()}
                <div className="col-xs-12">
                    {this.buildAddress()}
                    <h4 className="h3">{textValue.LIVING_PLACE.ESTATE_ADITIONAL_INFO}</h4>
                    <p>{textValue.LIVING_PLACE.SUMMARY}</p>
                    <br />
                    <div className="row">
                        {this.buildRadioButton(dataTypes.ADDRESS)}
                        {this.buildRadioButton(dataTypes.CRU)}
                        {this.buildCruIdufir()}
                        {this.buildRadioButton(dataTypes.REG_DATA)}
                        {this.buildRegData()}
                    </div>
                </div>
            </div>
        );
    }
}

LivingPlace.propTypes = {
    onBuildData: PropTypes.func,
    addressData: PropTypes.object,
    requestProvincesData: PropTypes.func,
    requestLocationData: PropTypes.func,
    mortgageRequestLocationData: PropTypes.object
};

module.exports.constructor = LivingPlace;
module.exports.LivingPlace = connect(
    state => ({
        mortgageRequestLocationData: state.mortgageRequestLocationData
    }), {
        requestProvincesData: getLocationData.requestProvincesData,
        requestLocationData: getLocationData.requestLocationData
    })(LivingPlace);
